/*
 * This file is part of the Det Norske Teatret application.
 *
 * (c) APT AS
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Video from 'components/Video/Video';
import Text from '../Text/Text';
import './VideoText.scss';

/**
 * This is the VideoText component.
 *
 * @author Thomas Sømoen <thomas@apt.no>
 *
 * @return {JSX}
 */
function VideoText({ layout, dropcap, text, video }) {
  return (
    <div className={`block video-text layout-${layout}`}>
      <div className="video-container" appear="true">
        <Video {...video} />
      </div>
      <Text dropcap={dropcap}>{text}</Text>
    </div>
  );
}

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
VideoText.propTypes = {
  layout: PropTypes.oneOf(['left', 'right']),
  dropcap: PropTypes.bool,
  text: PropTypes.string,
  video: PropTypes.object,
};

/**
 * Declare defaults for non-required props.
 *
 * @type {Object}
 */
VideoText.defaultProps = {
  layout: 'left',
  dropcap: false,
  text: '',
  video: {},
};

export default VideoText;
